module.exports = "<div class=asn-detail-rows-review-view-outer> <div class=\"q-marg-vert-md xs-pad-bottom q-pad-horz\"> <h4 class=\"q-title q-skinnier case-pallet-title\"> Shipping Quote </h4> </div> <div class=\"shipping-asn-details-rows-children-review-entry-point q-section-border-top q-marg-vert-md\"> target </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ReviewTab/html/asnDetailRowsReviewView.html
// module id = 1209
// module chunks = 1